import { render } from "./wednesday-afternoon.vue?vue&type=template&id=ba0faef2"
import script from "./wednesday-afternoon.vue?vue&type=script&lang=js"
export * from "./wednesday-afternoon.vue?vue&type=script&lang=js"
script.render = render

export default script